import { ManageCard } from "./ManageCard";
import {
  baseFeeEstimate,
  offeredTransformsType,
  transformsFeeLineItem,
} from "../utils";
import { IAddOnContext, IFlatAddOnDescriptor } from "../types";

/** Legacy flat-fee basic transforms. Cloud only — harbormaster has no self-hosted row. */
const transformsBasic = {
  productType: "transforms-basic",
  kind: "flat",
  title: "Transforms",

  isVisible: (ctx: IAddOnContext) =>
    !!ctx.subscribed || offeredTransformsType(ctx) === "transforms-basic",

  getUpsertAddOns: () => [
    { product_type: "transforms-basic", prepaid_units: 1 },
  ],

  getEstimateRowItem: (ctx) => ({
    detail: "Basic: SQL",
    price: baseFeeEstimate(ctx),
  }),

  getBillingRowItem: () => ({ detail: "Basic: SQL" }),
  getPurchaseLineItem: (ctx) => transformsFeeLineItem(ctx, "Basic"),

  ManageCard,
} satisfies IFlatAddOnDescriptor;

export default transformsBasic;
